/**
 * Feature flags for enabling/disabling features
 * Phone signup is kept in code but hidden behind this flag
 */
export const FEATURE_FLAGS = {
  ENABLE_PHONE_SIGNUP: false, // Set to true to re-enable phone signup
} as const;

